import { cDisplay, createParam } from "../cDisplay";
import { cScene } from "../cScene";
import { ScreenItem, ScreenObject } from "..//dataTypes";
import { net } from "../utils/net";
import { ModuleCollection, Base } from "./modules";
import { actionEvaluation } from "../actionEvaluation";


export class cInlineDisplay extends Phaser.GameObjects.Container {

  private disp!: cDisplay;
  private el: ScreenItem
  private onReadyCallback: Function 

  public modules: ModuleCollection;
  public sceneData!: ScreenObject
  public events: Phaser.Events.EventEmitter; 

  private actionEval!: actionEvaluation


  constructor (sc:cScene,data:ScreenItem, onReady:Function){
    super(sc);
    this.events = new Phaser.Events.EventEmitter()
    this.el = data;
    this.modules = Base.initModules(this,data);   
    this.onReadyCallback = onReady


    setTimeout( ()=>{
      this.load();
    },1);

    if (sc.debugMode){
      let _debugRect = new Phaser.GameObjects.Graphics(sc) //  this.ref.add.graphics();

      if (!data.asset) {
        console.warn('No Size in asset - for debugging')
        return
      }

      var r:any = this.modules.layout.getOfs( data.asset as string )
      if (!r) r={x:100,y:100}

      _debugRect.lineStyle(1, 0xff9900, 0.8);
      _debugRect.x = 0;
      _debugRect.y = 0;      
      _debugRect.fillStyle(0xff9900,0.2)
      _debugRect.fillRect(0,0,r.x,r.y)
      _debugRect.strokeRect(0, 0, r.x, r.y);
      this.add(_debugRect)
    }
  }


  load(){
    if (this.el && this.el.asset){
      net.fetchJson( net.gamedataFolder + this.el.asset + '/screen.json',{},(data:ScreenObject)=>{        

        let onCompleted = ()=>{
          if (this.checkAllAssets()){
            this.scene.load.off('complete',onCompleted);
            this.buildDisplay();          
          }
        }

        if (data.options.style){          
          (this.scene as cScene).sceneStyles = {...(this.scene as cScene).sceneStyles, ...data.options.style}
        }

        this.sceneData = data;
        (this.scene as cScene).preload( data.assets, net.serverUrl + net.gamedataFolder + this.sceneData.options.name + '/' )
        this.scene.load.on('complete',onCompleted);
        this.scene.load.start();        
      })
    }
  }

  checkAllAssets(){
    let okCount: number = 0
    let keys: string[] = this.scene.textures.getTextureKeys();
    this.sceneData.assets.forEach( (el)=>{
      okCount += keys.indexOf(el.name) !== -1 ? 1 : 0;
    })
    return okCount === this.sceneData.assets.length
  }


  buildDisplay(){
    

    var props:createParam = {
      type: this.sceneData.options.type,
      scene: this.scene,
      data: this.sceneData.screen as any,
      onReady:()=>{
      }
    }

    if (typeof this.sceneData.options.type != 'undefined' && cDisplay.DisplayTypeExists( this.sceneData.options.type )){
      this.disp = cDisplay.createDisplayType.call(null,props as any);
    }else{
      this.disp = new cDisplay(props.scene, props.data,  props.onReady);
    }

    if(this.sceneData.actions){
      this.actionEval = new actionEvaluation(this.scene as cScene,this.sceneData.actions)
      this.actionEval.container = this.disp
    }

    this.disp.events.addListener('action',(action:string, el:any, data:ScreenItem)=>{
      if (action === 'click'){
        this.actionEval.start( "on_click_" + data.name,{})
      }
    });

    this.add(this.disp);

    if (this.onReadyCallback){
      this.onReadyCallback();
    }

    setTimeout( ()=>{
      this.actionEval.start('on_enter',{})
    },1)

  }

  public close(cb:Function){
    this.disp.close(()=>{
      cb();
    })
  }

  public triggerSceneEvent(name:string, data:any = {}){
    data.event = name
    this.actionEval.start('on_sceneevent',data)
  }

  public command(command:string, opt:any){
    this.events.emit('action','custome',opt);
  }


}